import * as actionTypes from "./actionTypes";

export const showSnackbar = (message, severity) => {
    return {
        type: actionTypes.SHOW_SNACKBAR,
        message: message,
        severity: severity,
    };
};

export const hideSnackbar = () => {
    return {
        type: actionTypes.HIDE_SNACKBAR,
    };
};
